var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("KeyframeSlider", {
        attrs: { start: _vm.start, end: _vm.end },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var keyframe = ref.keyframe
              return [
                _vm.theDemo
                  ? _c(_vm.theDemo, {
                      tag: "component",
                      attrs: { keyframe: keyframe }
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _c("br"),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }